import { render, staticRenderFns } from "./EditCategory.vue?vue&type=template&id=7b927d2c"
import script from "./EditCategory.vue?vue&type=script&lang=js"
export * from "./EditCategory.vue?vue&type=script&lang=js"
import style0 from "./EditCategory.vue?vue&type=style&index=0&id=7b927d2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports